module.exports = __webpack_public_path__ + "img/icon-arrow-right.3989bfb9.svg";